<abc-popup
  style="padding: 0px 20px"
  #abcPopup
  [showTitle]="true"
  [visible]="false"
  [title]="'Gehe zu'"
  [position]="'center'"
  [deferRendering]="false"
  [height]="'40%'"
  [width]="'400px'"
  [shading]="true"
  [showCloseButton]="true"
  [resizeEnabled]="true"
  (onHiding)="onHiding()"
  (onInitialized)="onPopupInitialized($event)"
>
  <abc-list
    #abcList
    [dataSource]="targetLayouts"
    height="100%"
    searchMode="contains"
    searchEnabled="true"
    selectionMode="none"
    showScrollbar="always"
    displayExpr="layoutCaption"
    searchExpr="layoutCaption"
    keyExpr="layoutName"
    (onItemClick)="go($event.itemData)"
  >
  </abc-list>
</abc-popup>

<!-- <abc-select-box></abc-select-box> -->
